module.exports = __webpack_public_path__ + "img/event-bind-popup.bf380f3c.png";